import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Input } from '@mobiscroll/react-latest'
import { ClipLoader } from 'react-spinners'
import Label from '../common/Label'
import { PORTAL_INPUT_PROPS, RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'
import { IFormValues, IInputData } from './Login'

interface OtpFormProps {
  allowLogin: boolean
  focusedIndex: number
  formValues: IFormValues
  loading: boolean
  remainingTries: number
  handleInputChange: ({ name, value }: IInputData) => void
  handleOtpChange: (value: string, index: number) => void
  handleResendOtp: () => void
}

const OtpForm = ({
  allowLogin,
  focusedIndex,
  formValues,
  loading,
  remainingTries,
  handleInputChange,
  handleOtpChange,
  handleResendOtp
}: OtpFormProps) => {
  const [otpTimer, setOtpTimer] = useState(60)

  const { otp, otpRecipient } = formValues
  const { enterOtp, resendOTP, sendOTPtoEmail } = RIDER_PORTAL_UI_MESSAGES.auth

  useEffect(() => {
    const input = document.querySelector(`.otp-input-${focusedIndex}`) as HTMLInputElement
    if (input) {
      input.focus()
    }
  }, [focusedIndex])

  useEffect(() => {
    if (otpTimer === 0) {
      return
    }
    const timer = setInterval(() => setOtpTimer(t => (t > 1 ? t - 1 : 0)), 1000)
    return () => clearInterval(timer)
  }, [])

  const onResendOtp = () => {
    if (remainingTries > 1) {
      setOtpTimer(60)
    }
    handleResendOtp()
  }

  const handleCheckBoxChange = ({ name, value }: IInputData) => {
    const parseValue = value ? 'email' : 'sms'
    handleInputChange({ name, value: parseValue })
  }

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60)
    const remainingSeconds = time % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  return (
    <>
      <div className='otp-input-container text-center'>
        <Label htmlFor={enterOtp} text={enterOtp} />
        <div className='column-gap-16 flex mt1'>
          {Array.from({ length: 4 }, (_, index) => (
            <Input
              {...PORTAL_INPUT_PROPS}
              ariaLabel={`OTP digit ${index + 1} of 4`}
              inputClass={`otp-input otp-input-${index} portal-number-input`}
              key={index}
              name='otp'
              type='number'
              value={otp[index] || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpChange(e.target.value, index)}
            />
          ))}
        </div>
        <div className='mb2 relative'>
          {remainingTries < 3 && (
            <div className='absolute font-red fs-12 mbsc-align-right right-0 pt1 top-0'>
              {`${remainingTries} ${remainingTries <= 1 ? 'try' : 'tries'} remaining`}
            </div>
          )}
        </div>
      </div>
      <div className='mb2 mt2 pt1 w100'>
        <div className='flex'>
          <Checkbox
            checked={otpRecipient === 'email'}
            name='otpRecipient'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleCheckBoxChange({ name: 'otpRecipient', value: e.target.checked })
            }
          />
          <span className='font-grey7 text-sm'>{sendOTPtoEmail}</span>
        </div>
      </div>
      <div className='pt1 w100'>
        <Button
          ariaLabel={resendOTP}
          className='mbsc-rider-portal-success-btn w100'
          disabled={otpTimer !== 0 || !allowLogin || loading}
          onClick={onResendOtp}
        >
          {!loading ? (
            `${resendOTP}${otpTimer > 0 ? ` in ${formatTime(otpTimer)}` : ''}`
          ) : (
            <ClipLoader size={24} sizeUnit={'px'} color={'#405264'} loading={loading} />
          )}
        </Button>
      </div>
    </>
  )
}

export default OtpForm



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/authentication/OtpForm.tsx